import { useEffect, useState } from 'react';

/**
 * Portais precisam montar dentro de `#club-root`: os tokens de tema do clube
 * são escopados nesse elemento, então overlays no body herdam o tema neutro.
 */
export default function useClubPortalContainer(rootId = 'club-root') {
    const [container, setContainer] = useState(null);

    useEffect(() => {
        setContainer(document.getElementById(rootId));
    }, [rootId]);

    return container;
}
